import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    }
  },
  getters: {

  },
  actions: {
    getList ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getChannelList(token)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    add ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addChannel(token, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    delete ({ commit, state, dispatch }, id) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.deleteChannel(token, id)
            .then((res) => {
              dispatch('getList')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    analyticsAccessStep1 ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.analyticsChannelAccessGetLink(token, id)
            .then((res) => {
              resolve(res.body.link)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    analyticsSaveStats ({ dispatch }, { id, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.analyticsSaveStats(token, id, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
